module.exports = __webpack_public_path__ + "img/company.941f9bcd.svg";